import React, { useContext, useEffect, useState, useRef } from "react";
import { Controller, useForm } from "react-hook-form";
import { LoginContext } from "../../../../helpers/LoginContext";
import {
  baseURLImage, classNames,
  getNameProfile, parseBooleanVal,
  validateImage,
} from "../../../../Utils/utils";
import { useNavigate } from "react-router";

import CircularLoader from "../../../../components/common/CircularLoader/CircularLoader";
import Header from "../../../../components/common/Header/Header";
import SideBar from "../../../../components/common/SideBar/SideBarNew";
import CustomButton from "../../../../components/common/Button/CustomButton";
import Breadcrumb from "components/common/Breadcrumb";
import { toast } from "react-toastify";
import InsuranceSection from "./InsuranceSection";
import OrganizationPreferencesSection from "./OrganizationPreferencesSection";
import {
  SETTINGS_BREADCRUMB_PAGES,
  SP_SETTING_BREADCRUMB,
} from "Constants/BreadcrumbConstant";
import {
  REGEX_PHONE_NUMBER,
  STATES_LIST,
  USER_ROLE,
  CARE_SECTOR_OPTIONS,
} from "Constants/constant";
import InputField from "components/common/Input/Input";
import { apiPostRequest } from "../../../../helpers/Requests";
import RemoveFileAlert from "./Modals/RemoveFileAlert";
import ConfirmationModal from "components/common/Modal/ConfirmationModal";
import SelectOption from "components/common/Select/Select";
import moment from "moment/moment";
import DateRangeWithRegister from "components/common/DateRangePicker/DateRangePickerWithRegister";
import { roleAccess } from "helpers/RolesPermission";
import {payrollAccountTypesRequest, serviceTypesRequest} from 'helpers/apiCalls';
import usePayrollAuthentication from "../../../../hooks/usePayrollAuthentication";
import Loader from "../../../../components/common/Loader/Loader";
import refreshIcon from "../../../../assets/svg/refresh.svg";
import SwitchWithIcon from "components/common/SwitchWithIcon";

const SHIFT_SCREEN_FUNDING_TYPE_OPTIONS = [
  { value: "NDIS", label: "NDIS" },
  { value: "AGED_CARE", label: "Aged Care" },
  { value: "PRIVATE", label: "Private" },
  { value: "OTHER", label: "Other" },
];

const getMandatoryShiftFundingTypes = (careSector) => {
  if (careSector === "aged_care") return ["AGED_CARE"];
  if (careSector === "both") return ["NDIS", "AGED_CARE"];
  return ["NDIS"];
};

const normalizeShiftFundingTypeOptions = (optionsOrValues, careSector) => {
  const selectedValues = Array.isArray(optionsOrValues)
    ? optionsOrValues.map((item) => item?.value ?? item)
    : [];
  const values = Array.from(new Set([
    ...getMandatoryShiftFundingTypes(careSector),
    ...selectedValues,
  ]));
  return SHIFT_SCREEN_FUNDING_TYPE_OPTIONS.filter((option) =>
    values.includes(option.value)
  );
};

const SpSetting = (props) => {
  const {
    getSpSettingRequest,
    isLoading,
    settings,
    settingUpdateLoading,
    spSettingUpdateRequest,
    loginUser,
    spRosteringSetting,
    spRosteringSettingsRequest,
  } = props;
  const navigate = useNavigate();
  const { isAuthenticateForPayrolls, isCheckPayrollAuthLoading } = usePayrollAuthentication();
  const { sideBarPadding, isUserGracePeriodOver } = useContext(LoginContext);
  const [profilePicture, setProfilePicture] = useState(null);
  const [settingData, setSettingData] = useState(null);
  const [isUploading, setIsUploading] = useState(false);

  const [indemnityFile, setIndemnityFile] = useState(
    settings?.indemnity_file || null
  );
  const [liabilityFile, setLiabilityFile] = useState(
    settings?.liability_file || null
  );
  const [workersFile, setWorkersFile] = useState(
    settings?.workers_file || null
  );

  const [attachment, setAttachment] = useState(
    settings?.ndis_reg_attachment || null
  );

  const [attachmentRemoved, setAttachmentRemoved] = useState(false);
  const [fileRemoved, setFileRemoved] = useState(false);
  const [stateValue, setStateValue] = useState(
    STATES_LIST?.find((item) => item?.value === settings?.state) || null
  );
  const [serviceTypes, setServiceTypes] = useState([]);
  const [serviceTypesLoading, setServiceTypesLoading] = useState(true);
  const [xeroSyncLoader, setXeroSyncLoader] = useState([]);
  const [payrollAccountTypes, setPayrollAccountTypes] = useState([]);
  const [payrollAccount, setPayrollAccount] = useState([]);
  const [participantType, setParticipantType] = useState([]);
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [attachmentPreview, setAttachmentPreview] = useState(null);
  const inputRef = useRef(null);

  const {
    register,
    watch,
    handleSubmit,
    reset,
    formState: { errors },
    setValue,
    control,
  } = useForm({
    defaultValues: {
      branding_details: settings?.branding_text || "",
      attachment: settings?.ndis_reg_attachment,
    },
  });
  const brandingDetailsValue = watch("branding_details", "") || "";
  const watchedAttachment = watch("attachment");
  const [emailNotification, setEmailNotification] = useState(true);
  const [allowDocumentComments, setAllowDocumentComments] = useState(false);
  const [invoiceStartNumberChanged, setInvoiceStartNumberChanged] = useState(false);
  const [originalInvoiceStartNumber, setOriginalInvoiceStartNumber] = useState(null);
  const [xeroUseRosterInvoiceNumber, setXeroUseRosterInvoiceNumber] = useState(false);
  const [selectedCareSector, setSelectedCareSector] = useState(null);
  const [pendingCareSector, setPendingCareSector] = useState(null);
  const [selectedShiftScreenFundingTypes, setSelectedShiftScreenFundingTypes] = useState([]);
  const [userJourneyTracking, setUserJourneyTracking] = useState(false);

  const watchFormData = watch();
  useEffect(() => {
    setServiceTypesLoading(true);
    serviceTypesRequest()
      .then((res) => {
        setServiceTypes(res?.data || []);
      })
      .finally(() => {
        setServiceTypesLoading(false);
      });
  }, []);

  useEffect(() => {
    setXeroSyncLoader(true);
    payrollAccountTypesRequest().then(res => {
      setPayrollAccountTypes(res?.data || []);
      setXeroSyncLoader(false);
    });
  }, []);
  useEffect(() => {
    if (settings?.xero_selected_account_code && payrollAccountTypes.length) {
      // If the value is a string, make it an array for consistency
      const selectedCodes = Array.isArray(settings.xero_selected_account_code)
          ? settings.xero_selected_account_code
          : [settings.xero_selected_account_code];

      setPayrollAccount(
          payrollAccountTypes
              .filter(item => selectedCodes.includes(item.Code))
              .map(item => ({ value: item.Code, label: item.Name }))
      );
    }
  }, [settings, payrollAccountTypes]);
  useEffect(() => {
    if (!settings) return;

    setSettingData(settings);
    reset({ ...settings });
    setOriginalInvoiceStartNumber(
      settings?.invoice_start_number
        ? String(settings.invoice_start_number)
        : null
    );
    setXeroUseRosterInvoiceNumber(
      parseBooleanVal(settings?.xero_use_roster_invoice_number ?? false)
    );
    // Use parseBooleanVal to handle string/boolean/number values from backend
    // Check if value exists (including false/0/"false") to properly load saved state
    if (settings.hasOwnProperty('send_email')) {
      setEmailNotification(parseBooleanVal(settings.send_email));
    }
    // Backend field name is 'document_comments'
    if (settings.hasOwnProperty('document_comments')) {
      setAllowDocumentComments(parseBooleanVal(settings.document_comments));
    }
    if (settings?.care_sector) {
      const value = CARE_SECTOR_OPTIONS.find(
        (item) => item.value === settings.care_sector
      );
      setSelectedCareSector(value ?? CARE_SECTOR_OPTIONS[0]);
    } else {
      setSelectedCareSector(CARE_SECTOR_OPTIONS[0]);
    }
    const careSector = settings?.care_sector || CARE_SECTOR_OPTIONS[0]?.value || "ndis";
    setSelectedShiftScreenFundingTypes(
      normalizeShiftFundingTypeOptions(settings?.shift_screen_funding_types, careSector)
    );
  }, [settings, reset]);

  useEffect(() => {
    if (!Array.isArray(settings?.sp_service_types) || !serviceTypes.length) return;
    setParticipantType(
      serviceTypes
        .filter((item) => settings.sp_service_types.includes(item.id))
        .map((item) => ({ value: item.id, label: item.name }))
    );
  }, [settings?.sp_service_types, serviceTypes]);

  useEffect(() => {
    setValue("branding_name", settings?.slug);
    setValue("branding_details", settings?.branding_text);
  }, [settings?.slug, settings?.branding_text]);

  const syncXeroLedgerAccounts = async () => {
    setXeroSyncLoader(true);
    try {
      payrollAccountTypesRequest({ status: 'sync' }).then(res => {
        setPayrollAccountTypes(res?.data || []);
        setXeroSyncLoader(false); // Move here
      }).catch(() => {
        setXeroSyncLoader(false); // Also handle error
      });
    } catch (err) {
      setXeroSyncLoader(false);
    }
  };
  const onSubmit = async (data) => {
    if (isUserGracePeriodOver) {
      return;
    }
    let formData = new FormData();
    if (profilePicture) {
      const file = profilePicture ? profilePicture : "";
      const validFormats = ["image/jpeg", "image/png", "image/jpg"];
      if (!validFormats.includes(file.type)) {
        toast.error(
          "Invalid file format. Please upload a JPEG, JPG and PNG image to continue."
        );
        return;
      }
      if (file.size >= 2.1 * 1024 * 1024) {
        toast.error(
          "File too large. The maximum allowed size is 2MB. Try a smaller file."
        );
        return;
      }
      try {
        await validateImage(file);
        formData.append("profile_picture", file);
      } catch (error) {
        toast.error(error);
        return;
      }
    }
    formData.append("business_name", data.name ? data.name : "");
    formData.append("email", data.email ? data.email : "");
    formData.append("new_email", data.new_email ? data.new_email : "");
    formData.append("abn", data.abn ? data.abn : "");
    formData.append("asn", data.asn ? data.asn : "");
    formData.append("phone", data.phone ? data.phone : "");
    formData.append("post_code", data.post_code ? data.post_code : "");
    formData.append("state", stateValue ? stateValue?.value : "");
    formData.append("suburb", data.suburb ? data.suburb : "");
    formData.append(
      "street_address",
      data.street_address ? data.street_address : ""
    );
    formData.append(
      "bank_account_number",
      data.bank_account_number ? data.bank_account_number : ""
    );
    formData.append(
      "account_holder_name",
      data.account_holder_name ? data.account_holder_name : ""
    );
    formData.append("bsb", data.bsb ? data.bsb : "");
    formData.append("slug", data.branding_name ? data.branding_name : "");
    formData.append("branding_text", data?.branding_details || "");

    formData.append("ndis_reg_id", data.ndis_reg_id || "");
    formData.append("legal_company_name", data.legal_company_name || "");
    formData.append(
      "registration_start_date",
      data.registration_start_date || ""
    );
    formData.append("registration_end_date", data.registration_end_date || "");
    formData.append("mid_term_audit_date", data.mid_term_audit_date || "");

    if (data.attachment && data.attachment[0]) {
      formData.append("attachment", data.attachment[0]);
    }
    //formData.append("participant_type", participantType ? participantType.map(option => option.value) : []);
    participantType.forEach(option => {
      formData.append("participant_type[]", parseInt(option.value,10));
    });

    formData.append("send_email", emailNotification);
    formData.append("document_comments", allowDocumentComments);
    formData.append("user_journey_tracking", userJourneyTracking);
    formData.append("care_sector", selectedCareSector?.value ?? "ndis");
    normalizeShiftFundingTypeOptions(
      selectedShiftScreenFundingTypes,
      selectedCareSector?.value ?? "ndis"
    ).forEach((option) => {
      formData.append("shift_screen_funding_types[]", option.value);
    });

    formData.append(
      "indemnity_provider_name",
      data.indemnity_provider_name || ""
    );
    formData.append(
      "indemnity_policy_number",
      data.indemnity_policy_number || ""
    );
    formData.append(
      "indemnity_insurance_type",
      data.indemnity_insurance_type || ""
    );
    formData.append("indemnity_start_date", data.indemnity_start_date || "");
    formData.append("indemnity_end_date", data.indemnity_end_date || "");
    if (indemnityFile) formData.append("indemnity_file", indemnityFile);

    formData.append(
      "liability_provider_name",
      data.liability_provider_name || ""
    );
    formData.append(
      "liability_policy_number",
      data.liability_policy_number || ""
    );
    formData.append(
      "liability_insurance_type",
      data.liability_insurance_type || ""
    );
    formData.append("liability_start_date", data.liability_start_date || "");
    formData.append("liability_end_date", data.liability_end_date || "");
    if (liabilityFile) formData.append("liability_file", liabilityFile);

    formData.append("workers_provider_name", data.workers_provider_name || "");
    formData.append("workers_policy_number", data.workers_policy_number || "");
    formData.append(
      "workers_insurance_type",
      data.workers_insurance_type || ""
    );
    formData.append("workers_start_date", data.workers_start_date || "");
    formData.append("workers_end_date", data.workers_end_date || "");
    if (workersFile) formData.append("workers_file", workersFile);

    formData.append("invoice_email", data.invoice_email || "");
    if (roleAccess([USER_ROLE.Sp_Admin]) || loginUser?.is_manager_admin) {
      formData.append(
        "invoice_start_number",
        data.invoice_start_number ? data.invoice_start_number : ""
      );
      formData.append("xero_use_roster_invoice_number", xeroUseRosterInvoiceNumber);
    }
    formData.append("xero_selected_account_code", payrollAccount?.value || "");

    // Call the API to update settings
    await spSettingUpdateRequest(formData);

    // Refresh settings from backend to ensure we have the latest data including invoice_start_number
    await getSpSettingRequest();

    if (settings?.ndis_reg_attachment) {
      setAttachment(settings?.ndis_reg_attachment);
    }

    if (settings?.indemnity_file) {
      setIndemnityFile(settings?.indemnity_file);
    }

    if (settings?.liaility_file) {
      setLiabilityFile(settings?.liaility_file);
    }
    if (settings?.workers_file) {
      setWorkersFile(settings?.workers_file);
    }
    setAttachmentRemoved(false);
    setFileRemoved(false);

    // Update local state with the new email
    setSettingData((prev) => ({
      ...prev,
      email: data.new_email, // Update the email with the new email
    }));

    setInvoiceStartNumberChanged(false);
    setValue("new_email", "");
  };

  useEffect(() => {
    getSpSettingRequest();
    spRosteringSettingsRequest();
  }, []);

  useEffect(() => {
    if (spRosteringSetting?.hasOwnProperty("user_journey_tracking")) {
      setUserJourneyTracking(
        parseBooleanVal(spRosteringSetting.user_journey_tracking)
      );
    }
  }, [spRosteringSetting?.user_journey_tracking]);

  const handleUserJourneyTrackingChange = (value) => {
    if (isUserGracePeriodOver) {
      return;
    }
    setUserJourneyTracking(value);
  };

  const handleImageError = (e, fname, lname) => {
    return (e.target.src = getNameProfile(fname, lname));
  };
  const handleRemoveAttachment = async () => {
    setLoading(true);

    if (typeof attachment === "string" && !attachmentRemoved) {
      const payload = {
        type: "attachment",
        file: attachment,
      };

      try {
        const response = await apiPostRequest(
          "/sp/remove-attachment-file",
          payload
        );
        if (response.status === 200) {
          toast.success("File removed successfully.");
        }
      } catch (error) {
        toast.error(error?.message ?? "Error while removing file");
        setLoading(false);
        closeDialog();
        return;
      }
    }

    if (inputRef.current) {
      inputRef.current.value = "";
    }
    setValue("attachment", null);

    if (
      attachmentPreview &&
      typeof attachmentPreview === "string" &&
      attachmentPreview.startsWith("blob:")
    ) {
      URL.revokeObjectURL(attachmentPreview);
    }

    setAttachment(null);
    setAttachmentPreview(null);
    setAttachmentRemoved(true);

    setLoading(false);
    closeDialog();
  };

  const handleFileChange = (e) => {
    const file = e.target.files?.[0];

    if (!file) return;

    const isValidFileType = [
      "application/pdf",
      "application/msword",
      "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
      "image/jpeg",
      "image/png",
    ].includes(file.type);

    const isValidFileSize = file.size < 3.1 * 1024 * 1024;

    if (!isValidFileType) {
      toast.error(
        "Invalid file type. Please upload a file in PDF, DOC, DOCX, JPEG, or PNG format."
      );
      if (inputRef.current) inputRef.current.value = "";
      return;
    }

    if (!isValidFileSize) {
      toast.error("Attachment file size must be smaller than 3MB.");
      if (inputRef.current) inputRef.current.value = "";
      return;
    }

    setAttachment(file);

    if (file.type.startsWith("image/")) {
      const previewUrl = URL.createObjectURL(file);
      setAttachmentPreview(previewUrl);
    } else {
      setAttachmentPreview(null);
    }

    setValue("attachment", e.target.files);
    setAttachmentRemoved(false);
  };

  const handleFileRemoved = (sectioType) => {
    if (sectioType === "indemnity") setIndemnityFile(null);
    if (sectioType === "liability") setLiabilityFile(null);
    if (sectioType === "workers") setWorkersFile(null);
  };
  const openDialog = () => setIsDialogOpen(true);
  const closeDialog = () => setIsDialogOpen(false);

  const handleCareSectorChangeAttempt = (option) => {
    if (!option || option.value === selectedCareSector?.value) {
      return;
    }
    setPendingCareSector(option);
  };

  const confirmCareSectorChange = () => {
    if (!pendingCareSector) {
      return;
    }
    setSelectedCareSector(pendingCareSector);
    // Reset to mandatory types for the new care sector only — do not keep the
    // previous sector's funding type (e.g. Aged Care → NDIS should not leave AGED_CARE selected).
    setSelectedShiftScreenFundingTypes(
      normalizeShiftFundingTypeOptions([], pendingCareSector?.value ?? "ndis")
    );
    setPendingCareSector(null);
  };

  const cancelCareSectorChange = () => {
    setPendingCareSector(null);
  };

  const FIELD_LABELS = {
    name: "Business Name",
    phone: "Phone Number",
    abn: "ABN",
    asn: "ACN",
    street_address: "Street Address",
    state: "State",
    suburb: "Suburb",
    post_code: "Postcode",
    invoice_email: "Email for Invoices",
    account_holder_name: "Account Name",
    bsb: "BSB",
    bank_account_number: "Account Number",
    branding_name: "Custom Link",
    branding_details: "Branding Details",
    attachment: "Attachment",
  };

  const onInvalid = (errors) => {
    const keys = Object.keys(errors);
    if (keys.length === 0) return;
    const labels = keys.map(
      (key) => FIELD_LABELS[key] || key.replace(/_/g, " ")
    );
    const message =
      labels.length === 1
        ? `Please fix: ${labels[0]}`
        : `Please fix ${labels.length} fields: ${labels.join(", ")}`;
    toast.error(message);
    const firstKey = keys[0];
    const el = document.querySelector(`[name="${firstKey}"]`);
    if (el) {
      el.scrollIntoView({ behavior: "smooth", block: "center" });
      const focusable =
        el.matches("input, select, textarea")
          ? el
          : el.querySelector("input, select, textarea");
      if (focusable) {
        setTimeout(() => focusable.focus(), 400);
      }
    }
  };

  const inputErrorClass = "border-red-500 ring-1 ring-red-500";

  useEffect(() => {
    setIndemnityFile(settings?.indemnity_file || null);
    setLiabilityFile(settings?.liability_file || null);
    setWorkersFile(settings?.workers_file || null);
    setAttachment(settings?.ndis_reg_attachment || null);
  }, [settings]);

  return (
    <div>
      <div className='min-h-full'>
        <SideBar />
        <div
          className={`${
            sideBarPadding
              ? "lg:pl-[4rem] duration-300"
              : "lg:pl-64 duration-300"
          }  flex flex-col`}
        >
          <Header
            title='SP Settings'
            breadcrumb={
              <Breadcrumb
                pages={SP_SETTING_BREADCRUMB(
                  SETTINGS_BREADCRUMB_PAGES.SP_SETTING
                )}
              />
            }
          />
          <section className='w-full sm:px-6 lg:px-8 mt-3'>
            {!settingData || isLoading ? (
              <div
                className={`flex flex-col w-full min-h-screen bg-gray-50 items-center justify-center`}
              >
                <CircularLoader
                  classes='flex justify-center items-center'
                  classloader='loader-l'
                />
              </div>
            ) : (
              <div className='my-5 md:mt-0 md:col-span-2'>
                <form onSubmit={handleSubmit(onSubmit, onInvalid)}>
                  <div className='shadow sm:rounded-md sm:overflow-hidden'>
                    <div className='px-4 py-5 bg-white space-y-6 sm:p-6'>
                      <div className='grid grid-cols-2 gap-y-4 gap-x-5'>
                        <div>
                          <label className='block text-base font-medium text-gray-700'>
                            Profile Photo
                          </label>
                          <div className='mt-1 flex items-center'>
                            {profilePicture ? (
                              <img
                                className='object-cover w-10 h-10 rounded-full'
                                src={
                                  profilePicture
                                    ? URL.createObjectURL(profilePicture)
                                    : ""
                                }
                                alt=''
                              />
                            ) : (
                              <img
                                onError={(e) =>
                                  handleImageError(e, settingData.name, " ")
                                }
                                className='object-cover w-10 h-10 rounded-full'
                                src={
                                  settingData && settingData.profile_picture
                                    ? baseURLImage(settingData.profile_picture)
                                    : getNameProfile(settingData.name, " ")
                                }
                                alt=''
                              />
                            )}
                            <label
                              htmlFor='file-upload'
                              className='relative cursor-pointer bg-white rounded-md font-medium text-blue-600 hover:text-blue-500 focus-within:outline-none focus-within:ring-2 focus-within:ring-offset-2 focus-within:ring-blue-500 ml-5'
                            >
                              <span>Upload Image</span>
                              <span className='text-xs text-gray-400 ml-1'>
                                (File size must be less than 2MB)
                              </span>
                              <input
                                id='file-upload'
                                name='file-upload'
                                type='file'
                                className='sr-only'
                                accept='image/*'
                                onChange={(e) =>
                                  setProfilePicture(e.target.files[0])
                                }
                              />
                            </label>
                          </div>
                        </div>
                      </div>
                      <div className='grid grid-cols-2 gap-y-4 gap-x-5'>
                        <div>
                          <label
                              htmlFor='name'
                              className='capitalize block text-sm font-medium text-gray-700'
                          >
                            Business Name
                          </label>
                          <div className='mt-1'>
                            <input
                                maxLength={100}
                                type='text'
                                name='name'
                                id='name'
                                className={classNames(
                                  "did-floating-input capitalize",
                                  errors.name && inputErrorClass
                                )}
                                {...register("name", {
                                  required: true,
                                  maxLength: 254,
                                })}
                            />
                            {errors.name && (
                                <span className='text-red-500'>
                                This field is required
                              </span>
                            )}
                          </div>
                        </div>
                        <div>
                          <label
                              htmlFor='phone'
                              className='block text-sm font-medium text-gray-700'
                          >
                            Phone Number
                          </label>
                          <div className='mt-1'>
                            <input
                                type='number'
                                // minLength={10}
                                maxLength={10}
                                name='phone'
                                id='phone'
                                className={classNames(
                                  "did-floating-input",
                                  errors.phone && inputErrorClass
                                )}
                                {...register("phone", {
                                  // minLength: 10,
                                  maxLength: 10,
                                  pattern: REGEX_PHONE_NUMBER,
                                  onChange: (e) => {
                                    const sanitizedValue = e.target.value.replace(
                                        /\D/g,
                                        ""
                                    );
                                    const formattedValue = sanitizedValue.slice(
                                        0,
                                        10
                                    );
                                    e.target.value = formattedValue;
                                  },
                                })}
                            />
                            {errors.phone && (
                              <span className='text-red-500'>
                                {errors.phone.type === "required"
                                  ? "This field is required"
                                  : errors.phone.type === "pattern"
                                    ? "Please enter a valid phone number!"
                                    : errors.phone.type === "minLength"
                                      ? "Please enter a valid phone number with the min length of 10"
                                      : errors.phone.type === "maxLength"
                                        ? "Please enter a valid phone number (max 10 digits)"
                                        : "Please enter a valid phone number"}
                              </span>
                            )}
                          </div>
                        </div>
                        <div>
                          <InputField
                              label='Organization Email'
                              setValue={setValue}
                              register={register}
                              type='text'
                              //value='email'
                              name='email'
                              readOnly
                              defaultValue={"email"}
                          />
                        </div>
                        {loginUser?.is_manager_admin === false && (
                            <div>
                              <InputField
                                  label='Login email address'
                                  setValue={setValue}
                                  register={register}
                                  type='text'
                                  name='new_email'
                              />
                            </div>
                        )}

                        <div>
                          <label
                              htmlFor='abn'
                              className='block text-sm font-medium text-gray-700'
                          >
                            ABN
                          </label>
                          <div className='mt-1'>
                            <input
                                className={classNames(
                                  "did-floating-input",
                                  errors.abn && inputErrorClass
                                )}
                                {...register("abn", {
                                  required: true,
                                  pattern: "[0-9]*",
                                  maxLength: 11,
                                  minLength: 11,
                                  onChange: (e) =>
                                      (e.target.value = e.target.value
                                          .toString()
                                          .slice(0, 11)),
                                })}
                            />
                            {errors?.abn?.type === "required" ? (
                                <span className='text-red-500'>
                                This field is required
                              </span>
                            ) : errors.abn?.type === "pattern" ? (
                                <span className='text-red-500'>
                                Please enter a valid ABN
                              </span>
                            ) : errors.abn?.type === "maxLength" ||
                            errors.abn?.type === "minLength" ? (
                                <span className='text-red-500'>
                                Please enter a valid ABN with 11 digits
                              </span>
                            ) : null}
                          </div>
                        </div>
                        <div>
                          <label
                              htmlFor='asn'
                              className='block text-sm font-medium text-gray-700'
                          >
                            ACN
                          </label>
                          <div className='mt-1'>
                            <input
                                type='number'
                                name='asn'
                                id='asn'
                                className='did-floating-input'
                                {...register("asn", {
                                  pattern: "[0-9]*",
                                })}
                            />
                            {errors?.asn?.type === "required" ? (
                                <span className='text-red-500'>
                                This field is required
                              </span>
                            ) : errors.asn?.type === "pattern" ? (
                                <span className='text-red-500'>
                                Please enter a valid number
                              </span>
                            ) : null}
                          </div>
                        </div>
                        <div>
                          <label
                              htmlFor=''
                              className='block text-sm font-medium text-gray-700'
                          >
                            Street Address
                          </label>
                          <div className='relative mt-1'>
                            <input
                                type='text'
                                name='street_address'
                                id='street_address'
                                className={classNames(
                                  "did-floating-input ",
                                  errors.street_address && inputErrorClass
                                )}
                                {...register("street_address", {
                                  maxLength: 254,
                                })}
                            />
                            {errors.street_address && (
                                <span className='text-red-500'>
                                This field is required
                              </span>
                            )}
                          </div>
                        </div>
                        <div>
                          {/* <label
                            htmlFor=''
                            className='block text-sm font-medium text-gray-700'
                          >
                            State
                          </label> */}

                          <div className='did-floating-label-content w-full'>
                            <div className='hidden'>
                              <select
                                  {...register("state", {
                                    // value: false
                                    // required: true,
                                  })}
                                  name='state'
                                  id=''
                                  className='hidden did-floating-input'
                                  // defaultValue={false}
                              />
                            </div>
                            <label className='block mb-1 text-sm font-medium text-gray-700'>
                              State
                            </label>
                            <SelectOption
                                isSearch={false}
                                data={STATES_LIST}
                                selectedOption={stateValue}
                                handleChange={setStateValue}
                            />
                            {errors.state && (
                                <span className='text-red-500'>
                                This field is required
                              </span>
                            )}
                          </div>
                          {/* <div className='relative mt-1'>
                            <input
                              type='text'
                              name='state'
                              id='state'
                              className='did-floating-input '
                              {...register("state", {
                                maxLength: 254,
                              })}
                            />
                            {errors.state && (
                              <span className='text-red-500'>
                                This field is required
                              </span>
                            )}
                          </div> */}
                        </div>
                        <div>
                          <label
                              htmlFor=''
                              className='block text-sm font-medium text-gray-700'
                          >
                            Suburb
                          </label>
                          <div className='relative mt-1'>
                            <input
                                type='text'
                                name='suburb'
                                id='suburb'
                                className={classNames(
                                  "did-floating-input ",
                                  errors.suburb && inputErrorClass
                                )}
                                {...register("suburb", {
                                  maxLength: 254,
                                })}
                            />
                            {errors.suburb && (
                                <span className='text-red-500'>
                                This field is required
                              </span>
                            )}
                          </div>
                        </div>
                        <div>
                          <label
                              htmlFor='post_code'
                              className='block text-sm font-medium text-gray-700'
                          >
                            Postcode
                          </label>
                          <div className='mt-1'>
                            <input
                                type='number'
                                maxLength={4}
                                name='post_code'
                                id='post_code'
                                className={classNames(
                                  "did-floating-input",
                                  errors.post_code && inputErrorClass
                                )}
                                {...register("post_code", {
                                  maxLength: 4,
                                  pattern: "[0-9]*",
                                  onChange: (e) => {
                                    e.target.value = e.target.value
                                        .toString()
                                        .slice(0, 4);
                                  },
                                })}
                            />
                            {errors?.post_code?.type === "required" ? (
                                errors.post_code && (
                                    <span className='text-red-500'>
                                  This field is required
                                </span>
                                )
                            ) : (
                                <>
                                  {errors.post_code?.type === "pattern" && (
                                      <span className='text-red-500'>
                                    Please enter a valid number
                                  </span>
                                  )}
                                  {errors.post_code?.type === "maxLength" && (
                                      <span className='text-red-500'>
                                    Please enter a valid number
                                  </span>
                                  )}
                                </>
                            )}
                          </div>
                        </div>

                        <div className='mb-4'>
                          <label
                              htmlFor='ndis_reg_id'
                              className='block text-sm font-medium text-gray-700'
                          >
                            NDIS Registration ID
                          </label>
                          <input
                              type='text'
                              id='ndis_reg_id'
                              placeholder='e.g. ABC123 or 123456789'
                              {...register("ndis_reg_id")}
                              className='did-floating-input w-full mt-1'
                          />
                        </div>
                        <div className='mb-4'>
                          <label
                              htmlFor='legal_company_name'
                              className='block text-sm font-medium text-gray-700'
                          >
                            Legal Company Name
                          </label>
                          <input
                              type='text'
                              id='legal_company_name'
                              placeholder='e.g. ABC123 Pty Ltd'
                              {...register("legal_company_name")}
                              className='did-floating-input w-full mt-1'
                          />
                        </div>
                        <div className='mb-4'>
                          <label
                              htmlFor='registration_start_date'
                              className='block text-sm font-medium text-gray-700'
                          >
                            Registration Start Date
                          </label>
                          {/* <input
                              type="date"
                              id="registration_start_date"
                              {...register("registration_start_date")}
                              className="did-floating-input w-full mt-1"
                          /> */}
                          <Controller
                              name='registration_start_date'
                              control={control}
                              rules={{required: false}}
                              render={({field, fieldState}) => (
                                  <DateRangeWithRegister
                                      isSingleDate
                                      field={field}
                                      fieldState={fieldState}
                                      placeholder='Select Registration Start Date'
                                      showCalendarIcon
                                  />
                              )}
                          />
                        </div>
                        <div className='mb-4'>
                          <label
                              htmlFor='registration_end_date'
                              className='block text-sm font-medium text-gray-700'
                          >
                            Registration End Date
                          </label>
                          <Controller
                              name='registration_end_date'
                              control={control}
                              rules={{
                                required: false,
                                validate: (value) => {
                                  const start = watch(`registration_start_date`);
                                  if (!start || !value) return true;
                                  return (
                                      moment(value).isSameOrAfter(moment(start)) ||
                                      "End date must be after registration start date"
                                  );
                                },
                              }}
                              render={({field, fieldState}) => (
                                  <DateRangeWithRegister
                                      isSingleDate
                                      field={field}
                                      fieldState={fieldState}
                                      placeholder='Select Registration End Date'
                                      showCalendarIcon
                                  />
                              )}
                          />
                          {/* <input
                              type="date"
                              id="registration_end_date"
                              {...register("registration_end_date", {
                                validate: (value) => {
                                  const start = watch(`registration_start_date`);
                                  if (!start || !value) return true;
                                  return (
                                      moment(value).isSameOrAfter(moment(start)) ||
                                      "End date must be after registration start date"
                                  );
                                },
                              })}
                              className="did-floating-input w-full mt-1"
                          /> */}
                          {errors?.registration_end_date && (
                              <span className='text-red-500 text-sm'>
                              {errors?.registration_end_date.message}
                            </span>
                          )}
                        </div>
                        <div className='mb-4'>
                          <label
                              htmlFor='mid_term_audit_date'
                              className='block text-sm font-medium text-gray-700'
                          >
                            Mid-Term Audit Date
                          </label>
                          <Controller
                              name='mid_term_audit_date'
                              control={control}
                              rules={{required: false}}
                              render={({field, fieldState}) => (
                                  <DateRangeWithRegister
                                      isSingleDate
                                      field={field}
                                      fieldState={fieldState}
                                      placeholder='Select Mid Term Audit Date'
                                      showCalendarIcon
                                  />
                              )}
                          />
                          {/* <input
                              type="date"
                              id="mid_term_audit_date"
                              {...register("mid_term_audit_date")}
                              className="did-floating-input w-full mt-1"
                          /> */}
                        </div>

                        <div className='mb-4'>
                          <label
                              htmlFor='attachment'
                              className='block text-sm font-medium text-gray-700'
                          >
                            Attachment (Optional)
                          </label>
                          <div className='mt-1'>
                            {!attachment || attachmentRemoved ? (
                                <input
                                    type='file'
                                    ref={inputRef}
                                    id='attachment'
                                    disabled={isUploading}
                                    accept='.pdf,.doc,.docx,.jpg,.jpeg,.png'
                                    onChange={handleFileChange}
                                    className={`block w-full mt-1 text-sm text-gray-600 border border-gray-300 rounded-md file:mr-4 file:py-2 file:px-4 file:rounded-md file:border-0 file:text-sm file:font-semibold file:bg-blue-100 file:text-blue-700 ${
                                        isUploading
                                            ? "opacity-50 cursor-not-allowed"
                                            : "hover:file:bg-blue-200"
                                    }`}
                                />
                            ) : null}
                          </div>

                          {errors.attachment && (
                              <p className='text-sm text-red-600 mt-1'>
                                {errors.attachment.message}
                              </p>
                          )}

                          {(!attachment || attachmentRemoved) && (
                              <span className='text-sm text-gray-500'>
                              Upload a file in PDF, DOC, DOCX, JPEG, or PNG
                              format.
                            </span>
                          )}

                          {attachment && !attachmentRemoved && (
                              <div className='flex items-center justify-between border p-2 rounded-md bg-gray-50'>
                                <div className='text-sm text-gray-700 truncate max-w-[80%]'>
                                  {typeof attachment === "object" ? (
                                      attachment.type.startsWith("image/") &&
                                      attachmentPreview ? (
                                          <img
                                              src={attachmentPreview}
                                              alt='Preview'
                                              className='h-20 rounded-md'
                                          />
                                      ) : (
                                          <span className='text-sm text-blue-600'>
                                      {attachment.name}
                                    </span>
                                      )
                                  ) : (
                                      <a
                                          href={`https://docs.vertex360.io/${attachment}`}
                                          target='_blank'
                                          rel='noopener noreferrer'
                                          className='text-sm text-blue-600 underline mr-4'
                                      >
                                        {(typeof attachment === "string" &&
                                                attachment.split("/").pop()) ||
                                            "View existing file"}
                                      </a>
                                  )}
                                </div>

                                <div className='flex items-center space-x-2'>
                                  {!isUploading && (
                                      <button
                                          type='button'
                                          onClick={() => {
                                            if (
                                                typeof attachment === "string" &&
                                                !attachmentRemoved
                                            ) {
                                              openDialog();
                                            } else {
                                              handleRemoveAttachment();
                                            }
                                          }}
                                          className='text-red-600 hover:text-red-800 text-sm font-medium hover:underline'
                                          disabled={isUploading}
                                      >
                                        Remove
                                      </button>
                                  )}
                                </div>
                              </div>
                          )}
                        </div>
                        <div className='col-span-2'>
                          <OrganizationPreferencesSection
                            serviceTypes={serviceTypes}
                            serviceTypesLoading={serviceTypesLoading}
                            participantType={participantType}
                            setParticipantType={setParticipantType}
                            register={register}
                            showEmailNotificationToggle={roleAccess([USER_ROLE.Sp_Admin])}
                            emailNotification={emailNotification}
                            setEmailNotification={setEmailNotification}
                            showDocumentCommentsToggle={roleAccess([
                              USER_ROLE.Sp_Admin,
                              USER_ROLE.Sp_manager,
                            ])}
                            allowDocumentComments={allowDocumentComments}
                            setAllowDocumentComments={setAllowDocumentComments}
                            showUserJourneyTrackingToggle={roleAccess([
                              USER_ROLE.Sp_Admin,
                            ])}
                            userJourneyTracking={userJourneyTracking}
                            setUserJourneyTracking={handleUserJourneyTrackingChange}
                            userJourneyTrackingDisabled={isUserGracePeriodOver}
                            selectedCareSector={selectedCareSector}
                            onCareSectorChange={handleCareSectorChangeAttempt}
                            selectedShiftScreenFundingTypes={selectedShiftScreenFundingTypes}
                            setSelectedShiftScreenFundingTypes={setSelectedShiftScreenFundingTypes}
                            careSectorOptions={CARE_SECTOR_OPTIONS}
                            shiftScreenFundingTypeOptions={SHIFT_SCREEN_FUNDING_TYPE_OPTIONS}
                            normalizeShiftFundingTypeOptions={normalizeShiftFundingTypeOptions}
                            getMandatoryShiftFundingTypes={getMandatoryShiftFundingTypes}
                            isCheckPayrollAuthLoading={isCheckPayrollAuthLoading}
                            isAuthenticateForPayrolls={isAuthenticateForPayrolls}
                            payrollAccountTypes={payrollAccountTypes}
                            payrollAccount={payrollAccount}
                            setPayrollAccount={setPayrollAccount}
                            xeroSyncLoader={xeroSyncLoader}
                            syncXeroLedgerAccounts={syncXeroLedgerAccounts}
                            onConnectXero={() => navigate("/payroll-setting")}
                            invoiceEmailValue={watch("invoice_email")}
                            invoiceEmailError={errors.invoice_email?.message}
                            inputErrorClass={inputErrorClass}
                            showInvoiceStartNumber={
                              roleAccess([USER_ROLE.Sp_Admin]) || loginUser?.is_manager_admin
                            }
                            invoiceStartNumberError={errors.invoice_start_number?.message}
                            invoiceStartNumberChanged={invoiceStartNumberChanged}
                            originalInvoiceStartNumber={originalInvoiceStartNumber}
                            setInvoiceStartNumberChanged={setInvoiceStartNumberChanged}
                            xeroUseRosterInvoiceNumber={xeroUseRosterInvoiceNumber}
                            setXeroUseRosterInvoiceNumber={setXeroUseRosterInvoiceNumber}
                          />
                        </div>
                      </div>
                    </div>

                    <InsuranceSection
                        title='Professional Indemnity Insurance'
                        fileState={indemnityFile}
                        setFileState={setIndemnityFile}
                        existingFileUrl={settings?.indemnity_file}
                        sectionType='indemnity'
                        register={register}
                        watch={watch}
                        errors={errors}
                        onFileRemoved={handleFileRemoved}
                        control={control}
                        Controller={Controller}
                    />

                    <InsuranceSection
                        title='Public Liability Insurance'
                        fileState={liabilityFile}
                        setFileState={setLiabilityFile}
                        existingFileUrl={settings?.liability_file}
                        sectionType='liability'
                        register={register}
                        watch={watch}
                        errors={errors}
                        onFileRemoved={handleFileRemoved}
                        control={control}
                        Controller={Controller}
                    />

                    <InsuranceSection
                        title='Worker’s Compensation Insurance (WorkCover)'
                        fileState={workersFile}
                      setFileState={setWorkersFile}
                      existingFileUrl={settings?.workers_file}
                      sectionType='workers'
                      register={register}
                      watch={watch}
                      errors={errors}
                      onFileRemoved={handleFileRemoved}
                      control={control}
                      Controller={Controller}
                    />

                    <div className='px-4 py-3  bg-gray-50 sm:px-6 space-x-4 mt-6'>
                      <div className='pt-3 text-xl text-start'>
                        Bank Details
                      </div>
                      <divc className='m-0'>
                        <div className='grid grid-cols-4 gap-y-4 gap-x-5'>
                          <div className='col-span-2'>
                            <label
                              htmlFor=''
                              className='block text-sm font-medium text-gray-700'
                            >
                              Account Name
                            </label>
                            <div className='relative mt-1'>
                              <input
                                type='text'
                                name='account_holder_name'
                                id='state'
                                placeholder='Account Title'
                                className={classNames(
                                  "did-floating-input ",
                                  errors.account_holder_name && inputErrorClass
                                )}
                                {...register("account_holder_name", {
                                  required: false,
                                  maxLength: 100,
                                })}
                              />
                              {errors.account_holder_name && (
                                <span className='text-red-500'>
                                  This field is required
                                </span>
                              )}
                            </div>
                          </div>
                          <div className='col-span-1'>
                            <label
                              htmlFor='bsb'
                              className='block text-sm font-medium text-gray-700'
                            >
                              BSB
                            </label>
                            <div className='relative mt-1'>
                              <input
                                type='number'
                                name='bsb'
                                id='bsb'
                                placeholder='BSB'
                                className={classNames(
                                  "did-floating-input",
                                  errors.bsb && inputErrorClass
                                )}
                                onInput={(e) => {
                                  e.target.value = e.target.value.replace(
                                    /[^0-9]/g,
                                    ""
                                  );
                                }}
                                {...register("bsb", {
                                  required: false,
                                  maxLength: 6,
                                  pattern: "[0-9]*",

                                  onChange: (e) => {
                                    e.target.value = e.target.value
                                      .toString()
                                      .slice(0, 6);
                                  },
                                })}
                              />
                              {errors.bsb && (
                                <span className='text-red-500'>
                                  This field is required
                                </span>
                              )}
                            </div>
                          </div>
                          <div className='col-span-1'>
                            <label
                              htmlFor='bank_account_number'
                              className='block text-sm font-medium text-gray-700'
                            >
                              Account Number
                            </label>
                            <div className='mt-1'>
                              <input
                                type='tel'
                                name='bank_account_number'
                                id='bank_account_number'
                                placeholder='Account Number'
                                className={classNames(
                                  "did-floating-input",
                                  errors.bank_account_number && inputErrorClass
                                )}
                                onInput={(e) => {
                                  e.target.value = e.target.value.replace(
                                    /[^0-9]/g,
                                    ""
                                  );
                                }}
                                {...register("bank_account_number", {
                                  // required: "This field is required",
                                  required: false,
                                  pattern: {
                                    value: /^[0-9]+$/,
                                    message: "Please enter a valid number",
                                  },
                                })}
                              />

                              {errors.bank_account_number && (
                                <span className='text-red-500'>
                                  {errors.bank_account_number.message}
                                  This field is required
                                </span>
                              )}
                            </div>
                          </div>
                        </div>
                      </divc>
                    </div>

                    <div className='px-4 py-3  sm:px-6 space-x-4'>
                      <div className='pt-3 text-xl text-start'>
                        Login Page Branding
                      </div>
                      <divc className='m-0'>
                        <div className='grid grid-cols-2 gap-y-4 gap-x-5'>
                          <div className='col-span-1'>
                            <label
                              htmlFor=''
                              className='block text-sm font-medium text-gray-700'
                            >
                              Custom Link
                            </label>
                            <div className='relative mt-1'>
                              <span className='absolute inset-y-0 left-0 flex items-center pl-3 text-gray-500'>
                                https://app.vertex360.io/
                              </span>
                              <input
                                type='text'
                                name='branding_name'
                                placeholder=''
                                className={classNames(
                                  "did-floating-input",
                                  errors.branding_name && inputErrorClass
                                )}
                                style={{ paddingLeft: "193px" }}
                                {...register("branding_name", {
                                  required: false,
                                  maxLength: 100,
                                })}
                              />
                            </div>
                          </div>

                          <div className='col-span-1'>
                            <div className='flex justify-between items-center'>
                              <label
                                htmlFor='branding_details'
                                className='block text-sm font-medium text-gray-700'
                              >
                                Branding Details{" "}
                                <small>(Maximum 700 characters)</small>
                              </label>
                              <span className='text-sm text-gray-500 text-right'>
                                {brandingDetailsValue.length}/700
                              </span>
                            </div>
                            <div className='mt-1'>
                              <textarea
                                rows={1}
                                name='branding_details'
                                className={classNames(
                                  "w-full px-4 py-2 rounded-lg border-gray-300",
                                  errors.branding_details && inputErrorClass
                                )}
                                {...register("branding_details", {
                                  required: false,
                                  maxLength: 700,
                                })}
                              />
                              {errors.branding_details && (
                                <span className='text-red-500'>
                                  {errors.branding_details.message}
                                  Maximum 700 characters allowed!
                                </span>
                              )}
                            </div>
                          </div>
                        </div>
                      </divc>
                      <div className='text-right pt-3'>
                        <CustomButton
                          showLoading={settingUpdateLoading}
                          label='Save Changes'
                          isDisabled={
                            settingUpdateLoading || isUserGracePeriodOver
                          }
                          type='submit'
                        />
                      </div>
                    </div>
                  </div>
                </form>
              </div>
            )}
          </section>

          <RemoveFileAlert
            isOpen={isDialogOpen}
            loading={loading}
            onClose={closeDialog}
            onConfirm={handleRemoveAttachment}
          />

          <ConfirmationModal
            showModal={!!pendingCareSector}
            closeModalHandler={cancelCareSectorChange}
            submitHandler={confirmCareSectorChange}
            title='Change default care sector?'
            isNew={true}
            cancelBtnLabel='Keep current'
            confirmBtnLabel='Yes, change sector'
            variantConfirmBtn='primary'
          >
            <div className='space-y-3 text-sm leading-relaxed text-gray-700'>
              <p>
                You are changing the default care sector from{" "}
                <span className='font-medium text-gray-900'>
                  {selectedCareSector?.label || "the current sector"}
                </span>{" "}
                to{" "}
                <span className='font-medium text-gray-900'>
                  {pendingCareSector?.label}
                </span>
                .
              </p>
              <p>
                Schedules may already include{" "}
                {selectedCareSector?.label || "current"} line items. Changing
                this setting updates terminology and invoicing defaults for your
                organisation. Existing scheduled line items are not converted
                automatically.
              </p>
              <p>Do you want to continue?</p>
            </div>
          </ConfirmationModal>
        </div>
      </div>
    </div>
  );
};

export default SpSetting;
